import React, { FC, useState } from "react";
import { t } from "i18next";

import WelcomeBanner from "@components/common/WelcomeBanner";
import { Grid } from "@components/base";
import { useGetCurrentCsobCompanyInfo } from "@api";
import { useUserStore } from "@store/user";

interface CsobHubWelcomeBannerInterface {}

const CsobHubWelcomeBanner: FC<CsobHubWelcomeBannerInterface> = () => {
  const { user } = useUserStore();
  const [show, setShow] = useState(true);
  const { currentCsobCompanyInfo, isPendingGetCurrentCsobCompanyInfo } =
    useGetCurrentCsobCompanyInfo(user);

  const onClose = (): void => {
    setShow(false);
  };

  return show && !isPendingGetCurrentCsobCompanyInfo ? (
    <Grid size={12}>
      <WelcomeBanner
        color="blue"
        title={t("csob.hub.welcomeBanner.title")}
        text={
          currentCsobCompanyInfo?.credacCode
            ? t("csob.hub.welcomeBanner.description.withCredac")
            : t("csob.hub.welcomeBanner.description.withoutCredac")
        }
        icon="data-cloud"
        onClose={onClose}
      />
    </Grid>
  ) : null;
};

export default CsobHubWelcomeBanner;
